import React from 'react'
import { Link, useNavigate } from 'react-router-dom'

import AdminAccess from 'admin/components/common/AdminAccess'
import Alert from 'admin/components/common/Alert'
import PageFrame from 'admin/components/common/PageFrame'
import Text from 'admin/components/common/Text'
import {
  withContext,
  WithContextProps,
} from 'admin/components/common/withContext'
import { LoginState } from 'admin/redux/ducks/login'
import { OrganizationAdminState } from 'admin/redux/ducks/organizationAdmin'
import Loader from 'components/ui/Loader'
import { AdminTypes } from 'types'

const OrganizationAdminView: React.FunctionComponent<
  OrganizationAdminViewProps & WithContextProps
> = props => {
  const {
    deleteCallback,
    login,
    orgAdmin: { data, error, isLoading },
    locale,
  } = props

  const navigate = useNavigate()

  return (
    <PageFrame windowTitle={data && `${data.firstName} ${data.lastName}`}>
      <div className="Box">
        <h1>
          <Text>general.organization_admin</Text>
        </h1>
        <Alert alert={error} className="l-margin--b" />
        {data && (
          <div className="l-columns">
            <div className="l-flex l-margin--b">  
              <button className="button--hollow" type="button" onClick={() => navigate(-1)}>
                <Text>general.back</Text>
              </button>
            </div>
            <AdminAccess access={AdminTypes.ORG_ADMIN} login={login.data}>
              <div className="l-flex l-flex--fixed l-align--right l-margin--b">
                <Link
                  to={`/organisation/admin/andra/${data.kimId}`}
                  className="button"
                >
                  <Text>general.edit</Text>
                </Link>
                <div className="l-spacer-inline" />
                <button type='button' onClick={deleteCallback}>
                  <Text>general.delete</Text>
                </button>
              </div>
            </AdminAccess>
          </div>
        )}
        {data && (
          <div className="l-columns">
            <div className="l-flex l-flex--b50">
              <dl>
                <div>
                  <dt>
                    <Text>general.personal_id</Text>
                  </dt>
                  <dd>{locale.formatPersonalId(data.personalId)}</dd>
                </div>
                <div>
                  <dt>
                    <Text>general.name</Text>
                  </dt>
                  <dd>{`${data.firstName} ${data.lastName}`}</dd>
                </div>
              </dl>
            </div>
            <div className="l-flex__spacer--5" />
            <div className="l-flex l-flex--b50">
              <dl>
                <div>
                  <dt>
                    <Text>general.email</Text>
                  </dt>
                  <dd>
                    <a href={`mailto:${data.email}`}>{data.email}</a>
                  </dd>
                </div>
                <div>
                  <dt>
                    <Text>general.phone</Text>
                  </dt>
                  <dd>
                    <a href={`tel:${data.email}`}>{data.telephoneNumber}</a>
                  </dd>
                </div>
              </dl>
            </div>
          </div>
        )}
      </div>
      <Loader visible={isLoading} local />
    </PageFrame>
  )
}

type OrganizationAdminViewProps = {
  deleteCallback: any
  login: LoginState
  orgAdmin: OrganizationAdminState
}

export default (withContext(OrganizationAdminView))
